import React from "react";

export default function PdfReportPage({ bannerUrl, children, className = "" }) {
  const pageClassName = ["pdf-report-page", className].filter(Boolean).join(" ");

  return (
    <section className={pageClassName}>
      <div className="pdf-report-banner">
        <img alt="Health N Sync" src={bannerUrl} />
      </div>
      {children}
    </section>
  );
}
